import {
	Button
}from "antd"
import './style.css'
import PlusIcon from '../Icons/plus.svg'

export default ({ className, ...otherProps }) => {
	return (
		<Button
			{ ...otherProps }
			className={ `custom-add-btn ${ className ?? "" }` }
			type="text"
		>
			<img src={ PlusIcon } />
        Добавить
		</Button>
	)
}
